import React, { useContext, useEffect } from 'react';
import Tabs from '@mui/material/Tabs';
import { useParams } from 'react-router-dom';
import { useAccount } from 'wagmi';
import { ServicesContext } from '../../../context-providers/ServicesProvider';
import { positionsStore } from '../../../services/position/position.store';
import { marketsStore } from '../../../stores/MarketsStore';
import UserPositions from '../UserPositions/UserPositions';

import TradeTab from './TradeTab';
import UserPositionsHistory from '../UserPositionsHistory/UserPositionsHistory';
import UserActivity from '../UserActivity/UserActivity';
import './TradeTabsNavigation.scss';

const MarketTabValue = {
    POSITIONS: 'positions',
    ACTIVITY: 'activity',
    HISTORY: 'history'
}

const TradeTabsNavigation = () => {

    const { positionsManager } = useContext(ServicesContext);
    const { address } = useAccount();

    useEffect(() => {
        if (address) {
            positionsManager.fetchOpenPositions(address);
        } else {
            positionsStore.resetState()
        }
    }, [address]);

    const currentMarket = marketsStore.currentMarket

    const {  tab: routeTab } = useParams();
    const currentTab = routeTab || MarketTabValue.POSITIONS

    return (
        <div className="TradeTabsNavigation">
            <Tabs value={currentTab} TabIndicatorProps={{
                style: {
                    display: 'none'
                }
            }}>
                <TradeTab label={`Positions${positionsStore.openPositionsList.length ? ' (' + positionsStore.openPositionsList.length + ')' : ''}`} to={`/markets/${currentMarket?.marketId}`} value={MarketTabValue.POSITIONS} />
                <TradeTab label="Activity" to={`/markets/${currentMarket?.marketId}/activity`} value={MarketTabValue.ACTIVITY} />
                <TradeTab label="History" to={`/markets/${currentMarket?.marketId}/history`} value={MarketTabValue.HISTORY} />
            </Tabs>
            {currentTab === MarketTabValue.POSITIONS && <UserPositions />}
            {currentTab === MarketTabValue.ACTIVITY && <UserActivity />}
            {currentTab === MarketTabValue.HISTORY && <UserPositionsHistory />}
        </div>
    );
};

export default TradeTabsNavigation;